import React from 'react';
import scrollTo from '../utils/scrollTo';

const HEADER_HEIGHT = 80;

const scrollToReviews = () => {
	const reviewsContainer = document.getElementById('reviews');

	if (!reviewsContainer) return;

	scrollTo(reviewsContainer.offsetTop - HEADER_HEIGHT);
};

export default ({
	title,
	subtitle,
	description,
}) => (
	<div className="bg--gray-bg bb--gray-border">
		<div className="grid-container contained pt6 pb6 pt5--md pb5--md">
			<div className="row align--bottom">
				<div className="col c1 show--lg" />

				<div className="col c8--md c7--lg mb3 mb0--md">
					<h3 className="sans--small fw--600 uppercase mb2">
						{subtitle}
					</h3>
					<h2 className="domaine--medium mb2">
						{title}
					</h2>
					<p className="color--gray-text ws--pre-line">
						{description}
					</p>
				</div>
				<div className="col c4--md">
					<div className="show--md">
						<button
							title="View Reviews"
							onClick={scrollToReviews}
							name="reviews"
							className="button--secondary m--auto db">
							View Reviews
						</button>
					</div>
					<div className="hide--md">
						<button
							title="View Reviews"
							onClick={scrollToReviews}
							name="reviews"
							className="button--secondary full-width">
							View Reviews
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
);